import { render, staticRenderFns } from "./BillingContact.vue?vue&type=template&id=2f766099"
import script from "./BillingContact.vue?vue&type=script&lang=js"
export * from "./BillingContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports